export default __webpack_public_path__ + "static/media/illustration-algohealth-m@3x.d2f2572c.webp";